import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const ExpedienteCtx = createContext(null);

export function ExpedienteProvider({ children }) {
  const [exp, setExp] = useState(null);
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const [e, m] = await Promise.all([api.get("/portal/me"), api.get("/meta/hoja-vida")]);
      setExp(e.data); setMeta(m.data);
    } catch (err) {
      setError(err.response?.data?.detail ? formatApiErrorDetail(err.response.data.detail) : "No fue posible cargar tu expediente");
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return <ExpedienteCtx.Provider value={{ exp, setExp, meta, error, reload }}>{children}</ExpedienteCtx.Provider>;
}

export const useExpediente = () => useContext(ExpedienteCtx);
